import { Link } from 'react-router-dom'

interface MobileNavProps {
  isOpen: boolean
  onClose: () => void
  links: { label: string; href: string }[]
}

export default function MobileNav({ isOpen, onClose, links }: MobileNavProps) {
  if (!isOpen) return null

  return (
    <div className="fixed top-20 left-0 right-0 bottom-0 bg-brand-darker/[0.98] backdrop-blur-[20px] z-[99] flex flex-col gap-2 pt-10 px-6 min-[900px]:hidden">
      {links.map((link) => (
        <Link
          key={link.href}
          to={link.href}
          onClick={onClose}
          className="w-full text-brand-light text-2xl font-serif py-4 no-underline transition-colors duration-300 hover:text-accent-teal border-b border-white/[0.08]"
        >
          {link.label}
        </Link>
      ))}

      {/* Mobile CTA */}
      <Link
        to="/get-started"
        onClick={onClose}
        className="mt-6 w-full text-center bg-gradient-to-br from-[#14b8a6] to-[#10b981] text-[#1a1f2e] py-4 rounded-lg font-sans font-semibold text-base no-underline transition-all duration-300"
      >
        Get Started
      </Link>

      {/* Value of Advice Callout */}
      <Link
        to="/value-of-advice"
        onClick={onClose}
        className="mt-4 w-full flex items-center justify-center gap-2 bg-gradient-to-br from-[rgba(245,158,11,0.15)] to-[rgba(217,119,6,0.1)] border border-[rgba(245,158,11,0.4)] text-[#f59e0b] py-4 rounded-lg font-sans font-semibold text-[15px] no-underline transition-all duration-300 hover:from-[rgba(245,158,11,0.25)] hover:to-[rgba(217,119,6,0.2)] hover:border-[rgba(245,158,11,0.6)] hover:text-[#fbbf24]"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="9" />
          <text
            x="12"
            y="16"
            textAnchor="middle"
            fontSize="12"
            fontWeight="600"
            fill="currentColor"
            stroke="none"
          >
            £
          </text>
        </svg>
        Value of Advice
      </Link>
    </div>
  )
}
